// removed by extract-text-webpack-plugin
module.exports = {"title":"ProductionLeadTime__title__25Duh"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/ProductionLeadTime.scss
// module id = 1719
// module chunks = 4 14